import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { SessionStorageManager, SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES, paymentRoutes } from '@atlas/routing';

import { DEPOSIT_FAILED, REDIRECT_DATA_AFTER_DEPOSIT } from 'src/common/constants';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { payment } = clientProfileRoutes;
const { deposit } = paymentRoutes;

const getDepositFailedData = ({ alternativePmEnabled = false, pmId = null } = {}) =>
  JSON.stringify({
    alternativePmEnabled: !!alternativePmEnabled,
    pmId,
  });

const useRedirectAfterDeposit = () => {
  const { push: historyPush } = useHistory();

  useEffect(() => {
    const isDepositFailed =
      new URLSearchParams(window.location.search).get('deposit_failed') === 'true';

    const redirectData = SessionStorageManager.getItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (!redirectData) {
      if (!isDepositFailed) return;

      SessionStorageManager.setItem(DEPOSIT_FAILED, getDepositFailedData());
      const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
      historyPush(`${clientProfilePath}/${payment}/${deposit}`);
      return;
    }

    const { alternativePmEnabled, expirationTime, pmId, url } = JSON.parse(redirectData);

    SessionStorageManager.removeItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (Date.now() < expirationTime && url) {
      if (isDepositFailed) {
        SessionStorageManager.setItem(
          DEPOSIT_FAILED,
          getDepositFailedData({ alternativePmEnabled, pmId }),
        );
      }
      historyPush(url);
      return;
    }

    if (isDepositFailed) {
      const params = new URLSearchParams(window.location.search);
      params.delete('deposit_failed');
      const newSearch = params.toString();
      const searchSuffix = newSearch ? `?${newSearch}` : '';
      historyPush(`${window.location.pathname}${searchSuffix}`);
    }
  }, [historyPush]);
};

export default useRedirectAfterDeposit;
